import { clientDeleteCookie } from './commonUtils'

export const handleStartApplicationStorageData = (removeFunctions): void => {
  const removeAcceptDisclosures = removeFunctions?.acceptDisclosures
  const removeExistUserLocalStorage = removeFunctions?.existUserLocalStorage
  const removeUserExists = removeFunctions?.userExists
  if (removeFunctions) {
    removeExistUserLocalStorage?.()
    removeAcceptDisclosures?.()
    removeUserExists?.()
    if (document) {
      clientDeleteCookie(['opportunityId', 'contactId', 'data'])
      document.cookie =
        'email=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mpowerfinancing.com;'
      document.cookie =
        'otp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mpowerfinancing.com;'
    }
  }
}
